const Service = (type, action) => {
	let parsed = null;

	switch (type) {
		case "CYCLE.CREATE": {
			const payload = { ...action.payload };
			parsed = { type: "POST", url: "/api/review_cycle/save/", payload };
			break;
		}

		case "CYCLE.VALIDATE": {
			const payload = { ...action.payload };
			parsed = {
				type: "POST",
				url: "/api/review_cycle/validate/",
				payload,
			};
			break;
		}

		case "CYCLE.GET": {
			parsed = {
				type: "GET",
				url: `/api/review_cycle/${action.cycleId}/progress/meta/`,
			};
			break;
		}

		case "CYCLE.DETAILS": {
			parsed = {
				type: "GET",
				url: `/api/review_cycle/${action.cycleId}/details/`,
			};
			break;
		}

		case "CYCLE.PROGRESS": {
			parsed = {
				type: "GET",
				url: `/api/review_cycle/${action.cycleId}/progress/${action.functionName}/`,
			};
			break;
		}

		case "CYCLE.FILTER": {
			const payload = { ...action.payload };
			parsed = {
				type: "POST",
				url: `/api/review_cycle/${action.cycleId}/`,
				payload,
			};
			break;
		}

		case "CYCLE.EDIT": {
			const payload = { ...action.payload };
			parsed = {
				type: "POST",
				url: `/api/review_cycle/${action.cycleId}/edit/`,
				payload,
			};
			break;
		}

		case "CYCLE.GET_EXCLUSION_LIST": {
			const payload = {};
			parsed = {
				type: "POST",
				url: `/api/review_cycle/${action.cycleId}/add_users/`,
				payload,
			};
			break;
		}

		case "CYCLE.REMOVE_USER": {
			const payload = { reviewId: action.reviewId };
			parsed = {
				type: "DELETE",
				url: `/api/review_cycle/${action.cycleId}/users/`,
				payload,
			};
			break;
		}

		case "CYCLE.CLOSE": {
			parsed = {
				type: "POST",
				url: `/api/review_cycle/${action.cycleId}/close/`,
			};
			break;
		}

		case "CYCLE.DELETE": {
			parsed = {
				type: "POST",
				url: `/api/review_cycle/${action.cycleId}/delete/`,
			};
			break;
		}

		case "CYCLE.ADD_USERS": {
			const payload = { ...action.payload };
			parsed = {
				type: "POST",
				url: `/api/review_cycle/${action.cycleId}/run_add_users/`,
				payload,
			};
			break;
		}

		default:
			break;
	}

	return parsed;
};

export default Service;
